import DOMPurify from 'dompurify';
import { memo } from 'react';
import type { JSX } from 'react';

import { Props } from './types';

const RenderHTML = ({ html, className }: Props): JSX.Element => {
  const classes = className ? className : 'prose dark:prose-invert prose-sm';
  return (
    <div
      className={classes}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html)
      }}
    />
  );
};

export default memo(RenderHTML);
